export default "__VITE_ASSET__C25r6vNB__"